import React, { useEffect, useState } from "react";
import { Button, Form, OverlayTrigger, Spinner, Table, Tooltip } from "react-bootstrap";
import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    useReactTable,
    ColumnDef,
    getSortedRowModel,
    Row
} from "@tanstack/react-table";
import { Utils } from "../../common/utils";
import { CoursesCatalogInterface, CoursesCatalogStore, SectionsCatalogInterface } from "Stores/courseStore";
import { openDropdownStatus } from "./CourseCatalog";
import { StyledModal } from "Components/Common/StyledModal";
import { inject, observer } from "mobx-react";
import { LateralDrawer } from "Components/Common/LateralDrawer";
import { IngestionStore } from "Stores/index";
import DatePicker from "react-datepicker";
import { CalendarIcon } from "Components/Icons/CalendarIcon";
import { CircleAlertIcon } from "Components/Icons/CircleAlertIcon";
import { OverrideComment } from "Components/Common/OverrideComment";
import { SortAscendingIcon } from "Components/Icons/SortAscending";
import { SortDescendingIcon } from "Components/Icons/SortDescending";
import { TimesIcon } from "Components/Icons/TimesIcon";
import { CheckIcon } from "Components/Icons/CheckIcon";
import { DisabledIcon } from "Components/Icons/DisabledIcon";
import { CheckCircleIcon } from "Components/Icons/CheckCircleIcon";
import { EllipsisVerticalIcon } from "Components/Icons/EllipsisVerticalIcon";
export type rowSectionOptions = "edit" | "unmap" | "disable" | "";

export interface SectionRequest {
    name: string
    course_id: string
    term_id: number | string
    disabled: boolean
    needs_review: boolean
    course: string
    course_short_name: string
    course_title: string
    subject_number: string
    curriculum_year: string
    credit_hours: number
    override_comment: string
}

export interface NewSection {
    name: string
    term_type: string
    calendar_year: string
    term_order: number
    acad_year: string
    start_date: string
    end_date: string
}
interface CourseCatalogSubTableState {
    isOpenActions: openDropdownStatus;
    isOpenDrawerActions: rowSectionOptions;
    section: SectionsCatalogInterface | undefined
    isCreatingNewTerm: boolean
    startDate: Date | undefined
    endDate: Date | undefined
    isShowOverrideComment: boolean
    isTermValueChange: boolean
    isOverrideOpen: openDropdownStatus
    rowToDisplay: CoursesCatalogInterface
    acad_year_start: number
    termValue: string | number
    termType: string
    calendarYear: string | null
    formTermOrder: number | null
}
interface CourseCatalogSubTableProps {
    row: CoursesCatalogInterface
    coursesCatalogStore?: CoursesCatalogStore
    ingestionStore?: IngestionStore
    onCoursesRefetch: () => Promise<void>
    toast: (options: any) => void;

}
 export interface CourseSectionUnmapping {
    enflux_course_id: number,
    enflux_catalog_id: number,
    override_comment: string
}
@inject("coursesCatalogStore", "ingestionStore")
@observer
export class CourseCatalogSubTable extends React.Component<CourseCatalogSubTableProps, CourseCatalogSubTableState> {
    minDate = new Date("2/1/2000");
    years = Array.from(Array(17).keys()).map((e) => (e + 2014));

    constructor(props) {
        super(props);

        this.state = {
            isOpenActions: {
                id: "",
                open: false,
            },
            isOverrideOpen: {
                id: "",
                open: false
            },
            isOpenDrawerActions: "",
            section: undefined,
            isCreatingNewTerm: false,
            startDate: undefined,
            endDate: undefined,
            isShowOverrideComment: false,
            isTermValueChange: false,
            rowToDisplay: this.props.row || [],
            acad_year_start: this.minDate.getFullYear(),
            termValue: "",
            termType: "",
            calendarYear: null,
            formTermOrder: null,
        };
    }

    handleDocumentClick = (event) => {
        const dropdownButton = document.querySelector(".action-submenu-img-container");
        if (dropdownButton && !dropdownButton.contains(event.target)) {
            this.setState({ isOpenActions: { open: false, id: "" } });
        }
    };

    componentDidMount() {
        document.addEventListener("mousedown", this.handleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleDocumentClick);
    }
    renderTitle = (title: string) => {
        return (
            <div style={{ display: "flex", gap: 4 }}>
                {title}
            </div>
        );
    };

    onShowDrawerActions = (row: Row<SectionsCatalogInterface>, actionType: rowSectionOptions) => {
        if (actionType === "edit") {
            this.setState({ isOpenDrawerActions: actionType, section: row.original, termValue: row.original.term_id});
        } else {
            this.setState({ isOpenDrawerActions: actionType, section: row.original });
        }
    };

    handleStartDatePicker = (date: Date) => {
        this.setState({ startDate: date });
    };

    handleEndDatePicker = (date: Date) => {
        const dateEOD = Utils.changeDatePickerTimeStampToEOD(date);
        this.setState({ endDate: new Date(dateEOD) });
    };
    onSumbitDisabled = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const input = event.currentTarget.elements.namedItem("reason") as HTMLInputElement;
        const sectionToEdit: SectionRequest = {
            name: this.state.section?.name ?? "",
            course_id: this.state.section?.course_id ?? "",
            term_id: this.state.section?.term_id ?? "",
            disabled: this.state.section?.disabled ? false : true,
            course: this.state.section?.course ?? "",
            course_short_name: this.state.section?.course_short_name ?? "",
            curriculum_year: this.state.section?.curriculum_year ?? "",
            course_title: this.state.section?.course_title ?? "",
            subject_number: this.state.section?.subject_number ?? "",
            credit_hours: this.state.section?.credit_hours ?? 0,
            needs_review: false,
            override_comment: input.value
        };
        await this.props.coursesCatalogStore?.updateSectionCatalog(sectionToEdit, String(this.state.section?.id));
        this.setState({ isOpenDrawerActions: "" });
        await this.props.onCoursesRefetch();
    };

    onSumbitUnmap= async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const input = event.currentTarget.elements.namedItem("reason") as HTMLInputElement;
        const unmapping: CourseSectionUnmapping = {
            enflux_course_id: this.state.section?.id ?? 0,
            enflux_catalog_id: this.state.rowToDisplay?.rid ?? 0,
            override_comment: input.value
        };
        await this.props.coursesCatalogStore?.unmapCourse(unmapping);
        this.setState({ isOpenDrawerActions: "" });
        await this.props.onCoursesRefetch();
        await this.props.coursesCatalogStore?.fetchUnmappedSections(1, "");
    };

    onCreateNewTerm = () => {
        this.setState({ isCreatingNewTerm: true });
    };

    handleClickOnCalendarIconDate = (isStartDate: boolean) => {
        const calendarIcon = isStartDate ? document.getElementById("date-picker-input-start-date") as HTMLElement : document.getElementById("date-picker-input-end-date") as HTMLElement;
        calendarIcon.click();
    };

    setTermOrder = (calendarYear: string | null, termType: string) => {
        if (!calendarYear || !termType) {
            return;
        }
        let defaultTermOrder = calendarYear.slice(-2);
        const termTypeLower = termType.trim().toLowerCase();

        if (termTypeLower.includes("winter")) {
            defaultTermOrder += "1";
        } else if (termTypeLower.includes("spring")) {
            defaultTermOrder += "2";
        } else if (termTypeLower.includes("summer")) {
            defaultTermOrder += "3";
        } else if (termTypeLower.includes("fall")) {
            defaultTermOrder += "4";
        } else if (termTypeLower.includes("academic year")) {
            defaultTermOrder += "5";
        } else {
            defaultTermOrder += "6";
        }
        this.setState({ formTermOrder: Number(defaultTermOrder) });
    };

    handleTermTypeChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
        const termType = ev.target.value;
        this.setState({ termType }, () => {
            const { calendarYear } = this.state;
            if (calendarYear) {
                this.setTermOrder(calendarYear, termType);
            }
        });
    };

    handleCalendarYearChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
        const calendarYear = ev.target.value;
        this.setState({ calendarYear }, () => {
            const { termType } = this.state;
            if (termType) {
                this.setTermOrder(calendarYear, termType);
            }
        });
    };

    renderDrawerEdit = () => {
        const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const { elements } = event.currentTarget;
            if (this.state.isCreatingNewTerm) {
                const termName = elements.namedItem("term-name") as HTMLInputElement;
                const termType = elements.namedItem("term-type") as HTMLInputElement;
                const calendarYear = elements.namedItem("calendar-year") as HTMLInputElement;
                const academicYearStart = elements.namedItem("academic-year-start") as HTMLInputElement;
                const academicYearEnd = elements.namedItem("academic-year-end") as HTMLInputElement;

                if (!this.state.formTermOrder) {
                    console.error("Form term order is not set");
                    return;
                }

                const newSection: NewSection = {
                    name: termName.value,
                    term_type: termType.value,
                    term_order: this.state.formTermOrder,
                    calendar_year: calendarYear.value,
                    acad_year: `${academicYearStart.value}-${academicYearEnd.value}`,
                    start_date: this.state.startDate!.toISOString(),
                    end_date: this.state.endDate!.toISOString()
                };

                const onSuccess = async () => {
                    this.props.toast({
                        title: "Term Created",
                        message: "This section has been successfully linked to the new term",
                        type: "success",
                    });
                    await this.props.onCoursesRefetch();
                    await this.props.ingestionStore?.fetchTerms();
                    this.setState({ isCreatingNewTerm: false });
                    const newSelectedTerm = this.props.ingestionStore?.terms.find(term => term.name === newSection.name);

                    if (newSelectedTerm) {
                        const termSelect = document.getElementById("term-select") as HTMLSelectElement;

                        if (termSelect) {
                            setTimeout(() => {
                                this.setState({ isShowOverrideComment: true, isTermValueChange: true, termValue: newSelectedTerm.id.toString() });
                            }, 0);
                        }
                    }
                };

                const onError = (error: any) => {
                    this.props.toast({
                        title: "Term Wasn’t Created",
                        message: error?.response?.data?.message || "A term with the same name already exists",
                        type: "error",
                    });
                };

                this.props.coursesCatalogStore?.createTerm(newSection, onSuccess, onError);
            } else {
                const mappedTo = elements.namedItem("mapped-to") as HTMLInputElement;
                const reason = elements.namedItem("reason") as HTMLInputElement;
                const termSelect = document.getElementById("term-select") as HTMLSelectElement;
                const sectionToEdit: SectionRequest = {
                    name: this.state.section?.name ?? "",
                    course_id: mappedTo.value ?? "",
                    term_id: termSelect.value,
                    disabled: this.state.section?.disabled ?? false,
                    course: this.state.section?.course ?? "",
                    course_short_name: this.state.section?.course_short_name ?? "",
                    curriculum_year: this.state.section?.curriculum_year ?? "",
                    course_title: this.state.section?.course_title ?? "",
                    subject_number: this.state.section?.subject_number ?? "",
                    credit_hours: this.state.section?.credit_hours ?? 0,
                    needs_review: false,
                    override_comment: reason?.value ?? "  ",
                };
                await this.props.coursesCatalogStore?.updateSectionCatalog(sectionToEdit, String(this.state.section?.id));
                this.setState({ isOpenDrawerActions: "" });
                await this.props.onCoursesRefetch();
            }
            this.setState({isShowOverrideComment: false, isTermValueChange: false});
            const termSelect = document.getElementById("term-select") as HTMLSelectElement;
            termSelect.value = "";
        };

        const onCancelCreatingNewTerm = () => {
            this.setState({ isCreatingNewTerm: false, formTermOrder: null, termType: "", calendarYear: null });
            const termSelect = document.getElementById("term-select") as HTMLSelectElement;
            if (termSelect) {
                setTimeout(() => {
                    termSelect.value = "";
                }, 0);
            }
        };
        const onCancel = () => {
            this.setState({ isOpenDrawerActions: "", isCreatingNewTerm: false, isShowOverrideComment: false, isTermValueChange: false, formTermOrder: null, termType: "", calendarYear: null });
            const termSelect = document.getElementById("term-select") as HTMLSelectElement;
            termSelect.value = "";
        };

        const checkIfAcademicYearStartHasChangedValue = () => {
            const acad_year_start = document.getElementById("academic-year-start") as HTMLSelectElement;
            if (acad_year_start === null) return;
            if (acad_year_start.value === "") {
                return true;
            }
            return false;
        };

        return (
            <LateralDrawer
                isOpen={this.state.isOpenDrawerActions === "edit"}
                onClose={onCancel}
                title={this.state.isCreatingNewTerm ? "Edit section" : `Edit ${this.state.section?.name}`}
                confirmButton={{
                    title: "Save changes",
                    onClick: (e: React.FormEvent<HTMLFormElement>) => handleSubmit(e),
                    disabled: this.state.isCreatingNewTerm || !this.state.isTermValueChange
                }}
                cancelButton={{
                    title: "Cancel",
                    onClick: onCancel
                }}
            >
                <div className="drawer-form">
                    {this.state.isCreatingNewTerm && this.state.section?.name}
                    <Form.Group className="input-with-label">
                        <Form.Label className="label-input" htmlFor="term">
                            Term
                        </Form.Label>
                        <Form.Select
                            className="input-edit"
                            disabled={this.state.isCreatingNewTerm}
                            value={this.state.termValue || ""}
                            onChange={(ev) => this.setState({ isShowOverrideComment: true, isTermValueChange: true, termValue: ev.target.value })}
                            required
                            name="term"
                            id="term-select"
                        >
                            <option value={""} hidden >Choose term</option>
                            {this.props.ingestionStore?.terms?.map((term) => {
                                return (
                                    <option value={term.id} key={term.id}>{term.name}</option>
                                );
                            })}
                        </Form.Select>
                        <p className="text-end mt-1">
                            <Button size="sm" onClick={this.onCreateNewTerm}>+ Add new Term</Button>
                        </p>
                    </Form.Group>
                    <hr />
                    {this.state.isCreatingNewTerm && (
                        <>
                            <h3 className="create-new-term-title">Create new term</h3>
                            <Form.Group className="input-with-label">
                                <Form.Label className="label-input" htmlFor="term-name">
                                    Term name
                                </Form.Label>
                                <Form.Control
                                    id="term-name"
                                    className="input-edit"
                                    type="text"
                                    required
                                    name="term-name"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a name for the term.
                                </Form.Control.Feedback>
                            </Form.Group>
                            <div className="input-with-label two-columns">
                                <Form.Group>
                                    <div className="label-with-icon">
                                        <Form.Label className="label-input" htmlFor="term-name">
                                            Term type
                                        </Form.Label>
                                        <OverlayTrigger placement="right" overlay={<Tooltip style={{backgroundColor: "black", borderRadius: "5px"}} >Add a season here: Fall, Winter, Spring or Summer</Tooltip>}>
                                            <CircleAlertIcon />
                                        </OverlayTrigger>
                                    </div>
                                    <div className="input-container-with-icon">
                                        <Form.Control
                                            className="input-edit term-type"
                                            type="text"
                                            name="term-type"
                                            onChange={this.handleTermTypeChange}
                                            required
                                        />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a type for the term.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label className="label-input" htmlFor="calendar-year">
                                        Calendar year
                                    </Form.Label>
                                    <Form.Select
                                        id="calendar-year"
                                        className="input-edit calendar-year"
                                        required
                                        name="calendar-year"
                                        onChange={this.handleCalendarYearChange}
                                    >
                                        <option value={""}>Choose year</option>
                                        {this.years.map((year) => <option key={year} value={year}>{year}</option>)}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a name for the term.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label className="label-input" htmlFor="academic-year-start">
                                        Academic year start
                                    </Form.Label>
                                    <Form.Select
                                        id="academic-year-start"
                                        className="input-edit calendar-year"
                                        required
                                        name="academic-year-start"
                                        defaultValue={this.state.section?.term_id || ""}
                                        onChange={(val: React.ChangeEvent<HTMLSelectElement>) => this.setState({ acad_year_start: parseInt(val.target.value) }, () => {
                                            const academic_year_end = document.getElementById("academic-year-end") as HTMLSelectElement;
                                            academic_year_end.value = "";
                                        })}
                                    >
                                        <option value={""}>Choose year</option>
                                        {this.years.map((year) => <option key={year} value={year}>{year}</option>)}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a name for the term.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label className="label-input" htmlFor="calendar-year">
                                        Academic year end
                                    </Form.Label>
                                    <Form.Select
                                        id="academic-year-end"
                                        className="input-edit calendar-year"
                                        required
                                        name="academic-year-end"
                                        disabled={checkIfAcademicYearStartHasChangedValue()}
                                    >
                                        <option value={""}>Choose year</option>
                                        {this.years.map((year) => <option key={year} value={year}>{year}</option>)}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a name for the term.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div>
                                    <Form.Label className="label-input" htmlFor="date-picker-input-start-date">
                                        Start date
                                    </Form.Label>
                                    <div className="input-container-with-icon">
                                        <DatePicker
                                            required
                                            minDate={this.minDate}
                                            id="date-picker-input-start-date"
                                            className="date-picker-input"
                                            selected={this.state.startDate}
                                            onChange={(val) => this.handleStartDatePicker(val!)}
                                        />
                                        <CalendarIcon onClick={() => this.handleClickOnCalendarIconDate(true)} />
                                    </div>
                                </div>
                                <div>
                                    <Form.Label className="label-input" htmlFor="start-date">
                                        End date
                                    </Form.Label>
                                    <div className="input-container-with-icon">
                                        <DatePicker
                                            required
                                            disabled={this.state.startDate === undefined}
                                            minDate={this.state.startDate}
                                            id="date-picker-input-end-date"
                                            className="date-picker-input"
                                            selected={this.state.endDate}
                                            onChange={(val) => this.handleEndDatePicker(val!)} />
                                        <CalendarIcon onClick={() => this.handleClickOnCalendarIconDate(false)} />
                                    </div>
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a name for the term.
                                    </Form.Control.Feedback>
                                </div>
                            </div>
                            <div className="container-icons">
								<Button
									onClick={onCancelCreatingNewTerm}
									variant="outline-danger"
								>
									<TimesIcon className="d-flex" />
									Cancel
								</Button>
								<Button type="submit" variant="outline-success" disabled={this.props.coursesCatalogStore?.isLoadingCourses}>
									{this.props.coursesCatalogStore?.isLoadingCourses ? (
										<Spinner animation="border" size="sm" />
									) : (
										<>
											<CheckIcon className="d-flex" />
											Add term
										</>
									)}
								</Button>
							</div>
                        </>
                    )}
                    {!this.state.isCreatingNewTerm &&
                        <div>
                            <Form.Group className="input-with-label">
                                <Form.Label className="label-input" htmlFor="mapped-to">
                                    Mapped to
                                </Form.Label>
                                <Form.Select
                                    id="mapped-to"
                                    className="input-edit"
                                    required
                                    name="mapped-to"
                                    defaultValue={this.props.row.rid || ""}
                                    disabled={Boolean(this.props.row.rid)}
                                >
                                    {this.props.coursesCatalogStore?.coursesCatalog.map((course) => {
                                        const { rid, course_title } = course;
                                        return (
                                            <option key={rid} value={rid}>
                                                {course_title}
                                            </option>
                                        );
                                    })}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a name for the term.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>}

                        {this.state.isShowOverrideComment &&
                        !this.state.isCreatingNewTerm &&
                        <>
                            <hr />
                            <p>To continue, you need to share the reason for editing this section.</p>
                            <div>
                                <Form.Group className="input-with-label">
                                    <Form.Label className="label-input" htmlFor="mapped-to">
                                        Override comment
                                    </Form.Label>
                                    <Form.Control
                                        as={"input"}
                                        className="input-edit"
                                        name="reason"
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a name for the term.
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </>
                    }
                </div>
            </LateralDrawer >
        );
    };
    renderDisabledModal = () => {
        return (
            <StyledModal
                isOpen={this.state.isOpenDrawerActions === "disable" || this.state.isOpenDrawerActions === "unmap"}
                onClose={() => this.setState({ isOpenDrawerActions: "" })}
                title={`Are you sure you want to ${this.state.isOpenDrawerActions === "unmap" ?
                        "unmap" : this.state.section?.disabled ?
                        "enable" : "disable"} this section?`}
                subtitle={`To continue, you need to share the reason for ${this.state.isOpenDrawerActions === "unmap" ?
                        "umapping" : this.state.section?.disabled ?
                        "enabling" : "disabling"} this section`}
                cancelButtonLabel="Cancel"
                confirmButtonLabel={this.state.isOpenDrawerActions === "unmap" ?
                        "Unmap section" : this.state.section?.disabled ?
                        "Enable section" : "Disable section"}
                onSubmit={this.state.isOpenDrawerActions === "unmap" ? this.onSumbitUnmap: this.onSumbitDisabled}
            >
                <Form.Group>
                    <label>Override comment
                        <Form.Control
                            as={"input"}
                            name="reason"
                        />
                    </label>
                </Form.Group>
            </StyledModal>
        );
    };

    columnHelper = createColumnHelper<SectionsCatalogInterface>();
    columns = [
		this.columnHelper.accessor("subject_number", {
			header: () => (
				<div>
					{this.renderTitle("Subject Number")}
				</div>
			),
			cell: (value) => (
				<div>
					{value.getValue() === "" ? "-" : value.getValue()}
				</div>
			),
		}),
		this.columnHelper.accessor("course_title", {
			header: () => (
				<div>
					{this.renderTitle("Subject title")}
				</div>
			),
			cell: (value) => (
				<div style={{ textAlign: "left" }}>{value.getValue()}</div>
			),
		}),
		this.columnHelper.accessor("term_name", {
			header: () => this.renderTitle("Term"),
			cell: (value) => (value.getValue() === "" ? "-" : value.getValue()),
		}),
		this.columnHelper.accessor("disabled", {
			header: () => this.renderTitle("Status"),
			cell: (value) => (
				<div style={{ display: "flex", alignItems: "center", justifyContent: "left", paddingLeft: "10px" }}>
					<OverlayTrigger
						placement="top"
						overlay={
							<Tooltip
								style={{
									backgroundColor: "black",
									borderRadius: "5px",
								}}
							>
								{Boolean(value.getValue())
									? "Disabled"
									: "Enabled"}
							</Tooltip>
						}
					>
                        {
                            Boolean(value.getValue())
								? <DisabledIcon className="checkIcon" data-testid="check-icon" />
								: <CheckCircleIcon className="checkIcon" data-testid="check-icon" />
                        }
					</OverlayTrigger>
				</div>
			),
		}),
		this.columnHelper.accessor("override.changer.name", {
			header: () => this.renderTitle("Last Overridden By"),
			cell: (value) =>
				value.row.original.override.changer === undefined
					? "-"
					: value.row.original.override.changer.name,
		}),
		this.columnHelper.accessor("override.comment", {
			header: () => "Comment",
			cell: ({ row }) => (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "left", paddingLeft: "10px" }}>
                    <OverrideComment
                        isOpen={
                            String(row.original.id) === this.state.isOverrideOpen.id
                        }
                        onClick={() => {
                            this.setState({
                                isOverrideOpen: {
                                    id: this.state.isOverrideOpen.id
                                        ? ""
                                        : String(row.original.id),
                                    open: !this.state.isOverrideOpen.open,
                                },
                            });
                        }}
                        onClose={() => {
                            this.setState({
                                isOverrideOpen: { id: "", open: false },
                            });
                        }}
                        comment={row.original.override.comment}
                        date={row.original.override.date}
                        username={row.original.override?.changer?.name}
                        isDisabled={row.original.override.changer === undefined}
                    />
                </div>
			),
		}),
		this.columnHelper.display({
			id: "actions",
			cell: ({ row }) => (
				<MenuAction
					row={row}
					dropdownOpenId={String(this.state.isOpenActions.id)}
					isOpen={Boolean(this.state.isOpenActions.open)}
					onShowDrawer={(row, option) =>
						this.onShowDrawerActions(row, option)
					}
					toogleShowMenu={(newState) =>
						this.setState({ isOpenActions: newState })
					}
				/>
			),
		}),
	];
    render() {
        return (
            <div className="expandable-container">
                <SectionTable columns={this.columns} defaultData={this.props.row.sections ?? []} />
                {this.renderDisabledModal()}
                {this.renderDrawerEdit()}
            </div>
        );
    }
}

interface SectionsTableProps {
    defaultData: SectionsCatalogInterface[]
    columns: ColumnDef<SectionsCatalogInterface>[]
}
const SectionTable = ({ defaultData, columns }: SectionsTableProps) => {
    const [data, setData] = useState([...defaultData]);
    const table = useReactTable<SectionsCatalogInterface>({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
    });

    useEffect(() => {
        if (data !== defaultData) {
            setData([...defaultData]);
        }
    }, [defaultData]);
    return (
        <div className="sub-table-component mt-3">
            <Table className="sub-course-catalog-tabel">
                <thead>
                    {table.getHeaderGroups().map((groupHeader) => (
                        <tr key={groupHeader.id}>
                            {groupHeader.headers.map((header, index) => {
                                return (
                                    <th className={`th-${index}`} key={`${header.id}-${index}`} onClick={header.column.getToggleSortingHandler()}>
                                        <div className={`table_${header.id} header-div`}>
                                            {header.isPlaceholder
                                                ? null
                                                : flexRender(
                                                    header.column.columnDef.header,
                                                    header.getContext()
                                                )}
                                            {{
                                                asc: <SortAscendingIcon className="header-icon"/>,
                                                desc: <SortDescendingIcon className="header-icon"/>,
                                            }[header.column.getIsSorted() as string] ?? null}
                                        </div>
                                    </th>
                                );
                            })}
                        </tr>
                    ))}
                </thead>
                <tbody>
                    {table.getRowModel().rows.map((row, index) => (
                        <tr className="sub-viewers-row" key={`${row.id}-${index}`}>
                            {row.getVisibleCells().map((cell, index) => {
                                return (
                                    <td key={index}>
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                );
                            })}
                        </tr >
                    ))}
                </tbody>
            </Table>
        </div>
    );
};


interface MenuActionProps {
    row: Row<SectionsCatalogInterface>;
    onShowDrawer: (row: Row<SectionsCatalogInterface>, option: rowSectionOptions) => void
    toogleShowMenu: (newState: openDropdownStatus) => void
    dropdownOpenId: string,
    isOpen: boolean
}
export const MenuAction = ({ row, onShowDrawer, dropdownOpenId, isOpen, toogleShowMenu }: MenuActionProps) => {
    const renderMenu = (props) => {
        return (
            <Tooltip {...props} aria-hidden={isOpen ? "false" : "true"} bsPrefix="course-catalog-tooltip">
                <div className="action-menu-container">
                    {<div className="action-menu-item" onClick={() => {
                        onShowDrawer(row, "edit");
                        toogleShowMenu({ id: "", open: false });
                    }}>
                        Edit
                    </div>}
                    <div className="action-menu-item" onClick={async () => {
                        onShowDrawer(row, "unmap");
                        toogleShowMenu({ id: "", open: false });
                    }}>
                        Unmap
                    </div>
                    <div className="action-menu-item" onClick={() => {
                        onShowDrawer(row, "disable");
                        toogleShowMenu({ id: "", open: false });
                    }}>
                        {row.original.disabled ? "Enable" : "Disable"}
                    </div>
                </div>
            </Tooltip>
        );
    };
    return (
        <div style={{ width: 40 }} className="action-submenu-img-container">
            <OverlayTrigger rootClose trigger={"click"} overlay={renderMenu} show={dropdownOpenId === String(row.original.id) && isOpen} placement="auto">
                <EllipsisVerticalIcon className="threeDotsIcon" data-testid="dots-action" id="dots-action"
                    onClick={() => {
                        toogleShowMenu({ id: dropdownOpenId === String(row.original.id) ? "" : String(row.original.id), open: isOpen ? false : true });
                    }} />
            </OverlayTrigger >
        </div >
    );
};